export default __webpack_public_path__ + "static/media/zona-comercial.0df53820.svg";